import type { TToggleButtonGroupOption } from '@shared/components';
import { TERMINOLOGY } from '@shared/i18n';

import { EAiRunFeedbackReason } from './types';

export const AI_ASSISTANT_SIDEBAR_WIDTH_PX = 350;

export const AI_ASSISTANT_OVERLAY_WIDTH_PX = 400;

export const AI_ASSISTANT_SHORT_TITLE = 'Reg AI';

export const AI_ASSISTANT_TITLE = 'Regulatory AI';

export const AI_ASSISTANT_DISCLAIMER = 'AI can make mistakes. Check important info.';

export const AI_CONNECTION_LOST_MESSAGE = 'The connection was lost. Please try again.';

export const getAiOlderVersionMessage = (hasDraft: boolean) =>
  `Older version. ${TERMINOLOGY.askButton.upper} uses the ${hasDraft ? 'draft' : 'latest'}.`;

export const AI_OUT_OF_SCOPE_TITLE = 'Not supported.';
export const AI_NO_ANSWER_FOUND_TITLE = 'Not found.';
export const AI_NOTHING_TO_CHANGE_TITLE = 'No changes needed.';
export const AI_UNCLEAR_REQUEST_TITLE = 'Request unclear.';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/ai/useCases/runs/dtos/aiRunFeedback.dto.ts
export const AI_RUN_FEEDBACK_COMMENT_MAX_CHARS = 500;

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/ai/useCases/runs/dtos/aiContentSelection.dto.ts
export const AI_CONTENT_SELECTION_TEXT_MAX_CHARS = 4000;
export const AI_CONTENT_SELECTION_ELEMENT_IDS_MAX = 100;

// Stored html length above which the fast model returns only a handful of suggestions for a whole document.
export const AI_ADVANCED_MODE_MIN_DOCUMENT_CHARS = 350_000;

export const AI_RUN_FEEDBACK_REASON_OPTIONS: readonly TToggleButtonGroupOption<EAiRunFeedbackReason>[] = Object.freeze([
  { value: EAiRunFeedbackReason.INCORRECT, label: 'Incorrect' },
  { value: EAiRunFeedbackReason.MISSING_SOURCE, label: 'Missing source' },
  { value: EAiRunFeedbackReason.UNCLEAR, label: 'Unclear' },
  { value: EAiRunFeedbackReason.UNSAFE, label: 'Unsafe' },
  { value: EAiRunFeedbackReason.OTHER, label: 'Other' },
]);
